import React from 'react'
import {
  FormDashboardLabel as Label,
} from '../'
import Select from 'react-select'
import { useCities } from '../../features/cities/hook'

const CitySelect = ({ defaultValue, onChange }) => {
  const { options }  = useCities()

  return (
    <>
      <Label>City</Label>
      <Select
        className="text-sm"
        options={options}
        placeholder="Choose City"
        defaultValue={defaultValue}
        onChange={onChange}
      />
    </>
  )
}

export { CitySelect }
